import {
	type AddTenantEmailDomainMutation,
	type RemoveTenantEmailDomainMutation,
	type ValidateTenantEmailDomainMutation
} from "~/gql/mutations/tenantEmailDomain.generated";
import { type GetTenantEmailDomainQuery } from "~/gql/queries/tenantEmailDomain.generated";

export const emailDomainEndpoints = {
	AddTenantEmailDomain: {
		invalidatesTags: ["TenantEmailDomain"] as AddTagTypes,
		transformResponse: (res: AddTenantEmailDomainMutation) => res
	},
	GetTenantEmailDomain: {
		providesTags: ["TenantEmailDomain"] as AddTagTypes,
		transformResponse: (res: GetTenantEmailDomainQuery) => res
	},
	RemoveTenantEmailDomain: {
		invalidatesTags: ["TenantEmailDomain"] as AddTagTypes,
		transformResponse: (res: RemoveTenantEmailDomainMutation) => res
	},
	ValidateTenantEmailDomain: {
		invalidatesTags: ["TenantEmailDomain"] as AddTagTypes,
		transformResponse: (res: ValidateTenantEmailDomainMutation) => res
	}
};
